import { contatos_empty } from "@/components/Form/Contatos/get_contacts_empty.js";
import { endereco_empty } from "@/components/Form/Endereco/get_endereco_empty.js";

export const getPagination = ({ pagination }) => pagination;
export const pessoa_fisica_empty = () => ({
  nome: "",
  cpf: "",
  rg: "",
  curriculo: {},
  curriculo_id: null,
  endereco: endereco_empty(),
  contatos: contatos_empty(),
});
